import { ModelDataType } from 'src/app/interfaces/model-data-type';

import { BaseModel } from './base-model';

export class CompanyRanking extends BaseModel {
  static CompanyRankingProperties: (
    | {
        property: keyof CompanyRanking;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof CompanyRanking;
        type: 'alias';
      }
    | {
        property: keyof CompanyRanking;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    { property: 'CompanyId', type: 'column', dataType: 'number' },
    { property: 'priorityLevel', type: 'column', dataType: 'number' },
    { property: 'rank', type: 'column', dataType: 'string' },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' }
  ];

  static {
    CompanyRanking.CompanyRankingProperties.forEach((propertyObject) => {
      const { property, type } = propertyObject;
      if (type === 'column') {
        CompanyRanking.columnMap.set(property, propertyObject);
      }
      if (type === 'alias') {
        CompanyRanking.aliasedColumnMap.set(
          property,
          propertyObject as { property: string; type: 'alias' }
        );
      }
      if (type === 'association') {
        CompanyRanking.associationMap.set(
          property,
          propertyObject as {
            property: string;
            type: 'association';
            model: string;
          }
        );
      }
    });
  }

  constructor(CompanyRankingObject: Partial<CompanyRanking>) {
    super();

    CompanyRanking.CompanyRankingProperties.forEach((propertyObject) => {
      const { property } = propertyObject;
      const value = CompanyRankingObject[property];
      if (value !== undefined) {
        Object.assign(this, { [property]: value });
      }
    });
  }

  id?: number;
  CompanyId?: number;
  priorityLevel?: number;
  rank?: string;
  createdAt?: Date;
  updatedAt?: Date;
}
